<template>
  <div ref="whole_page" class="w-full">
    <div v-if="subjects.length == 0">
      <div class="vx-row ml-0">
        <div class="vx-col mx-auto">
          <p style="color:white;font-weight:500;font-size:16px;padding-top:5px">No classrooms or subjects yet...</p>
        </div>
      </div>
      <!-- <vs-divider /> -->
      <div class="vx-row ml-0 mt-5">
        <div class="vx-col mx-auto">
          <vs-button type="border" @click="addNewClassroom">Add New Classroom</vs-button>
        </div>
      </div>
    </div>
    <div v-else-if="!showClasses">
      <div class="vx-row ml-0">
        <div class="vx-col">
          <vs-button type="border" @click="addNewClassroom">Add New Classroom</vs-button>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-1/2 mx-auto" style="align-self: center;">
        <ul style="margin-top: 3px;flex-wrap: wrap;" :key="variable">
          <li v-for="(_subject, subjIndex) in subjects" :key="subjIndex" class="mb-4">
            <vx-card class="glow-effect_dark limit-width_fixed-scalable__teacher-subjects card__no-padding bg-color">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                    <img height="29" :src="getIcon(_subject.id)" />
                  </div>
                </template>

                <div class="vx-row">
                  <div class="vx-col w-2/5">
                    <vs-button
                      size="large"
                      class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient less-padding"
                      style="border-radius:0 7px 7px 0"
                      @click="selectSubject(_subject)">
                      {{ _subject.name }}
                    </vs-button>
                  </div>

                  <div class="vx-col w-3/5" style="padding-left: 0rem;padding-right: 1.4rem;align-self: center;margin-top: 0.4rem !important;">
                    <span class="flex"><vs-progress :height="14" :percent="upperValue" color="success"></vs-progress><p class="ml-2" style="margin-top: -0.1rem !important; width:23px"><strong>{{upperValue}}</strong></p></span>
                    <span class="flex"><vs-progress :height="14" :percent="lowerValue" color="success"></vs-progress><p class="ml-2" style="margin-top: -0.1rem !important; width:23px"><strong>{{lowerValue}}</strong></p></span>
                  </div>
                </div>
              </vx-input-group>
            </vx-card>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="showClasses">
      <vs-divider />
      <div class="vx-row ml-0">
        <div class="ml-5">
          <vs-button type="border" @click="addNewClassroom">Add New</vs-button>
        </div>
        <div class="vx-col" style="margin-left: 34% !important;">
          <h1 class="text__school-font-color">Classrooms</h1>
        </div>
      </div>
      <div class="mt-4 w-full">
      <ul style="margin-top: 3px;flex-wrap: wrap;">
        <li v-for="(item, index) in selectedSubject.classrooms" :key="index" class="mb-4">
          <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                  <span><feather-icon class="pt-1" icon="BookOpenIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                style="border-radius:0 7px 7px 0"
                @click="handleSelectedClassroom(item)">
                {{ item.classroom.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </ul>
    </div>
    </div>

    <vs-popup id="classroom-popup" ref="classroompopup" fullscreen :title="popupTitle" class="vs-con-loading__container" :active.sync="classroomPopupActive">
      <vs-divider class="mb-6">Classroom Details</vs-divider>
      <div class="vx-row pb-3">
        <div id="teacher-dropdown-container" class="vx-col sm:w-1/2 w-full mb-2">
          <label>Teacher</label>
          <v-select :disabled="true" ref="teacherDropdown" class="w-full" placeholder="Search / Select a Teacher" :options="teachersDropdownList" v-model="teacherDropdown"></v-select>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Subject</label>
          <v-select ref="subjectDropdown" class="w-full style-chooser" placeholder="Search / Select a Subject" :options="subjectsDropdownList" v-model="subjectDropdown"></v-select>
        </div>
      </div>
      <div class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Name</label>
          <vs-input id="password_input" autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required'" name="Classroom Name" icon-pack="feather" icon="icon-briefcase" icon-no-border v-model="formData.name" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Year</label>
          <datepicker id="password_input" class="w-full" v-model="year" format="yyyy" :minimumView="'year'" :maximumView="'year'"></datepicker>
        </div>
      </div>
      <div class="vx-row pb-3">
        <div class="vx-col w-full mb-2">
          <label>Description</label>
          <vs-textarea class="w-full" v-model="formData.description" />
        </div>
      </div>

      <div v-show="formData.id">
        <vs-divider>Students</vs-divider>
        <div>
          <vs-table :sst="true" ref="allStudentsTable" class="vs-con-loading__container" @search="handleUnassignedStudentsSearch" @change-page="handleUnassignedStudentChangePage" stripe single pagination :max-items="unassignedPageSize" search :data="students">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
              <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
                <h3 class="ml-2">Ready-to-Assign</h3>
              </div>
            </div>
            <template slot="thead">
              <vs-th sort-key="userFirstName">Name</vs-th>
              <vs-th sort-key="mobile">Mobile Number</vs-th>
              <vs-th sort-key="idNumber">ID Number</vs-th>
              <vs-th sort-key="email">Email</vs-th>
              <vs-th>Assign</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="student" :state="student.isActive == false ? 'warning' : null" :key="indextr" v-for="(student, indextr) in data" >

                <vs-td :data="data[indextr].userFirstName">
                  {{ student.userFirstName + " " + student.userLastName }}
                </vs-td>

                <vs-td :data="data[indextr].mobile">
                  {{ student.mobile }}
                </vs-td>

                <vs-td :data="data[indextr].idNumber">
                  {{ student.idNumber }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ student.email }}
                </vs-td>

                <vs-td>
                  <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignStudent(student.id)"></vs-button>
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </div>
        <vs-divider></vs-divider>
        <div>
          <vs-table :sst="true" ref="assignedStudentsTable" @search="handleAssignedStudentsSearch" @change-page="handleAssignedStudentChangePage" class="vs-con-loading__container" stripe single pagination :max-items="assignedPageSize" search :data="assignedStudents">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
              <div class="p-3 mr-4 flex items-center justify-between font-medium text-base">
                <h3 class="ml-2">Already Assigned</h3>
              </div>
            </div>
            <template slot="thead">
              <vs-th sort-key="studentFullName">Name</vs-th>
              <vs-th sort-key="studentMobile">Mobile Number</vs-th>
              <vs-th sort-key="studentIdNumber">ID Number</vs-th>
              <vs-th sort-key="studentEmail">Email Address</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="student" :state="assignedStudents.isActive == false ? 'warning' : null" :key="indextr" v-for="(student, indextr) in data" >

                <vs-td :data="data[indextr].userFirstName">
                  {{ student.userFirstName + " " + student.userLastName }}
                </vs-td>

                <vs-td :data="data[indextr].mobile">
                  {{ student.mobile }}
                </vs-td>

                <vs-td :data="data[indextr].idNumber">
                  {{ student.idNumber }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ student.email }}
                </vs-td>

                <vs-td>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="unassignStudent(student.id)"></vs-button>
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>

      <vs-divider class="mb-6 pt-0"></vs-divider>
      <div class="vx-row">
        
      </div>
      <div class="vx-row pl-4">
        <div class="vx-col" v-show="formData.id">
          <vs-button v-show="isBulkAddHidden" color="success" type="border" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="bulkStudentAdd" ref="bulkAddButton">Bulk Student Add</vs-button>
          <div class="flex flex-wrap items-center justify-center">
            <div class="vs-con-loading__container">
              <v-uploader v-show="!isBulkAddHidden && !bulkCsvFileUrl" @done="csvSuccessUpload" ref="bulkUpload" file-type-exts="csv" button-text="Upload .csv" language="en" file-size-limit="100MB" :preview="false"></v-uploader>
            </div>
            <vs-button v-show="bulkCsvFileUrl" ref="confirmBulkButton" color="success" size="small" class="mb-4 mr-3" @click="confirmBulkStudentAdd">Add Students</vs-button>
            <vs-button v-show="!isBulkAddHidden" :disabled="!canCancel" color="warning" size="small" class="mb-4 ml-3" @click="cancelBulkAdd">Close</vs-button>
          </div>
        </div>
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <div class="vx-row mr-0">
            <vx-card ref="saveEditButton" card-background="#11193f" class="glow-effect_dark limit-width_short card__no-padding vs-con-loading__container">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                    <span><feather-icon class="pt-1" icon="SaveIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  :disabled="isSaveClassroomBtnDisabled"
                  size="large"
                  class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                  style="border-radius:0 7px 7px 0"
                  @click="saveEditClassroom">
                  Save
                </vs-button>
              </vx-input-group>
            </vx-card>
            <vx-card card-background="#11193f" class="glow-effect_dark limit-width_short card__no-padding vs-con-loading__container" style="margin-left: 22px;">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                    <span><feather-icon class="pt-1" icon="XIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  size="large"
                  color="warning"
                  class="w-full glow-effect_warning button-text__left-align"
                  style="border-radius:0 7px 7px 0"
                  @click="classroomPopupActive = false">
                  {{ formData.id ? 'Close' : 'Cancel' }}
                </vs-button>
              </vx-input-group>
            </vx-card>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup id="bulkNotAddedPopup" title="Information of Students NOT Added" class="vs-con-loading__container" :active.sync="bulkNotAddedPopupActive">
      <div v-if="bulkAddResponse && bulkAddResponse.totalNotAdded != 0">
        <table id="bulkResponseTable" style="width: 100%;" > 
          <tr>
            <th>Row no.</th>
            <th>Name</th>
            <th>Email</th>
            <th>Reason</th>
          </tr>
          <tr class="ml-0" v-for="(item, index) in bulkAddResponse.studentsNotAdded" :key="index">
            <td>
              {{ item.rowNumber }}
            </td>
            <td>
              {{ item.firstname }} {{ item.lastname }}
            </td>
            <td>
              {{ item.email }}
            </td>
            <td>
              {{ item.message }}
            </td>
          </tr>
        </table>

        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col" style="display: flex;">
            <vs-button class="mt-4" icon-pack="feather" icon="icon-copy" @click="selectElementContents('bulkResponseTable')">Copy to Clipboard</vs-button>
            <vs-button class="mt-4 ml-4" color="success" icon-pack="feather" icon="icon-download" @click="exportBulkToExcel">Download .csv</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

  </div>
</template>


<script>
import defaultIcon from '../assets/subjecticons/default.svg'
import mathsIcon from '../assets/subjecticons/maths.svg'
import mathsliteracyIcon from '../assets/subjecticons/maths-literacy.svg'
import afrikaanshomeIcon from '../assets/subjecticons/afrikaans-home.svg'
import afrikaansfirstIcon from '../assets/subjecticons/afrikaans-first.svg'
import englishhomeIcon from '../assets/subjecticons/english-home.svg'
import englishfirstIcon from '../assets/subjecticons/english-first.svg'
import lifeskillsIcon from '../assets/subjecticons/life-skills.svg'
import lifesciencesIcon from '../assets/subjecticons/life-sciences.svg'
import socialscienceIcon from '../assets/subjecticons/social-science.svg'
import lifeorientationIcon from '../assets/subjecticons/life-orientation.svg'
import naturalscienceandtechnologyIcon from '../assets/subjecticons/natural-science-and-technology.svg'
import geographyIcon from '../assets/subjecticons/geography.svg'
import economicsIcon from '../assets/subjecticons/economics.svg'
import accountingIcon from '../assets/subjecticons/accounting.svg'
import tourismIcon from '../assets/subjecticons/tourism.svg'
import naturalscienceIcon from '../assets/subjecticons/natural-science.svg'
import historyIcon from '../assets/subjecticons/history.svg'
import egdIcon from '../assets/subjecticons/eng-graphics-and-design.svg'
import technologyIcon from '../assets/subjecticons/technology.svg'
import computerapptechnologyIcon from '../assets/subjecticons/computer-app-technology.svg'
import itIcon from '../assets/subjecticons/it.svg'
import electricaltechnologyIcon from '../assets/subjecticons/electrical-technology.svg'
import mechanicaltechnologyIcon from '../assets/subjecticons/mechanical-technology.svg'
import civiltechnologyIcon from '../assets/subjecticons/civil-technology.svg'
import businessstudiesIcon from '../assets/subjecticons/business-studies.svg'
import consumerstudiesIcon from '../assets/subjecticons/consumer-studies.svg'
import physicalscienceIcon from '../assets/subjecticons/physical-science.svg'
import chessIcon from '../assets/subjecticons/chess.svg'
import creativeartsIcon from '../assets/subjecticons/creative-arts.svg'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    vSelect,
    Datepicker
  },
  data() {
    return {
      math: [38,39,47,51,54,55,56,57,58,59,89,130,139,141,143,145,148,150,176,189,196,225,236,248,259,261,341,361,367,380,388,389,398,400,408,412,417],
      mathLit: [44,115,124,266,268,269,349,368,393],
      afrHuis: [40,41,60,61,62,63,165,201,202,204,250,252,258],
      afrEat: [46,64,78,80,91,200,206,211,213,238,239,240,676],
      engHome: [52,90,92,98,100,131,215,228,232,235,244,245,246],
      engFal: [53,81,82,83,132,163,192,193,195,241,242,243,332,343,370,390,399,518],
      lifeSkill: [45,49,79,88,103,104,109,110,197,198,334,409,410,414,421],
      lifeScience: [48,106,113,310,311,313,359,371,395],
      socScience: [71,72,116,117,118,119,126,184,186,187,205,207],
      lifeOrient: [84,85,86,154,155,157,249,251,253,255,256,257,527],
      natSciTech: [42,50,74,77,185,191],
      geography: [94,95,96,97,99,105,344,378,391],
      econManSci: [120,122,125,175,177,178],
      economics: [128,133,135,229,230,231,354,376,394],
      accounting: [136,138,146,210,212,216,345,373,392],
      tourism: [156,158,160,180,199,348,372,403,511,512,513],
      natScience: [111,112,114,181,182,183],
      history: [140,142,144,147,149,151,342,374,404,429],
      egd: [127,129,134,260,263,267],
      tech: [171,172,174,188,190,194],
      compAppTech: [137,152,161,214,220,223],
      it: [164,167,179,270,271,272],
      elecTech: [291,292,293],
      mechTech: [315,316,317],
      civilTech: [318,319,320],
      busStudy: [153,159,166,219,221,222,346,365,405,495,506,507],
      consStud: [168,170,173,233,234,237],
      physScience: [208,209,218,224,226,227,347,369,397],
      chess: [335,336,337,338],
      agriSci: [350,366,402],
      arts: [362],
      isixhosa: [333,352,387,401],
      subjects: [],
      selectedSubject: null,
      showComingSoon: false,
      showClasses: false,
      classroomPopupActive: false,
      teachersDropdownList: [],
      teacherDropdown: 0,
      subjectsDropdownList: [],
      subjectDropdown: 0,
      formData: {
        id: 0,
        name: "",
        description: null,
        teacherId: null,
        courseId: null,
        year: null
      },
      year: null,
      headerTitleBulk: ["RowNumber","Firstname","Lastname","Email","Message"],
      headerValBulk: ["rowNumber","firstname","lastname","email","message"],
      bulkNotAddedPopupActive: false,
      studentsNotAdded: "",
      bulkCsvFileUrl: "",
      canCancel: true,
      isLoading: false,
      isBulkAddHidden: true,
      bulkAddResponse: {},
      students: [],
      assignedStudents: [],
      loadingColor: "#fff",
      selectedStudent: {
        id: 0,
        name: "",
        transactions: []
      },
      criteria:{
        unassignedPageNumber : 1,
        unassignedPageSize: 10,
        unassignedSearchPhrase: "",
        assignedPageNumber: 1,
        assignedPageSize: 10,
        assignedSearchPhrase: "",
      },
      unassignedPageSize: 10,
      assignedPageSize: 10,
      currentUserId: null,
      popupTitle: "",
      variable: 0
    };
  },
  watch: {
    classroomPopupActive: function(val) {
      var self = this;
      if(!val) {
        self.initValues();
        if (self.selectedSubject) {
          self.getSubjectsAndClassess(function(){
            self.selectSubject(self.selectedSubject);
          });
        }
        else {
          self.getSubjectsAndClassess();
        }
      }
    }
  },
  computed: {
    upperValue: function() {
      return 0;
      // return Math.floor(Math.random() * 101);
    },
    lowerValue: function() {
      return 0;
      // return Math.floor(Math.random() * 101);
    },
    isSaveClassroomBtnDisabled: function() {
      return !((this.subjectDropdown && this.subjectDropdown.value) && this.formData.name)
    }
  },
  methods: {
    initValues() {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.description = null;
      this.formData.teacherId = null;
      this.formData.courseId = null;
      this.formData.year = null;
      this.year = new Date();
      this.isLoading = false;
      this.bulkCsvFileUrl = "";
      this.canCancel = true;
      this.students = [];
      this.assignedStudents = [];

      this.selectedStudent.id = 0;
      this.selectedStudent.name = "";
      this.selectedStudent.transactions = [];

      this.teacherDropdown = 0;
      this.subjectDropdown = 0;
       
      this.errors.clear();
    },
    getTeachersDropdownData() {
      var self = this;

      var onSuccess = response => {
        self.teachersDropdownList = response.data.map((item) => {return {label: item.text, value: item.value} });
      };
      
      self.$ajaxGet(self, "user/GetTeachers", onSuccess);
    },
    getSubjectsDropdownData() {
      var self = this;

      var onSuccess = response => {
        self.subjectsDropdownList = response.data.map((item) => {return {label: item.text, value: item.value} });
      };
      
      self.$ajaxGet(self, "Course/GetSelectList", onSuccess);
    },
    getSubjectsAndClassess(whenDone) {
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');
      
      var onSuccess = function(response) {
        if (response.data && response.data.length >= 0) {
          self.variable += 1;
          self.subjects = response.data.sort((a, b) =>
            a.name > b.name ? 1 : -1
          );
          if (whenDone && typeof whenDone == "function")
            whenDone();
        }
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, "Course/Teacher/GetData", onSuccess, onFinally);
    },
    addNewClassroom() {
      var self = this;
      self.initValues();
      self.popupTitle = "Add Classroom";
      self.classroomPopupActive = true;
      self.teacherDropdown = self.teachersDropdownList.filter(function (item) { return item.value == self.currentUserId; })[0];
    },
    handleSelectedClassroom(param) {
      var self = this;
      self.popupTitle = "Edit Classroom";

      self.classroomPopupActive = true;

      self.formData.id = param.classroom.id;
      self.formData.name = param.classroom.name;
      self.formData.description = param.classroom.description;
      
      if (param.classroom.year) {
        self.year = new Date(param.classroom.year, 1, 1);
      }
      else {
        self.year = new Date();
      }
      
      self.teacherDropdown = self.teachersDropdownList.filter(function (item) { return item.value == self.currentUserId; })[0];
      self.subjectDropdown = self.subjectsDropdownList.filter(function(item){return item.value == param.classroom.courseId;})[0];

      self.addUploaderClickEvents();
      self.loadStudentData(param.classroom.id);
      self.getAssignedStudents(param.classroom.id);
    },
    
    selectSubject(subject) {
      var self = this;
      self.showClasses = false;
      self.selectedSubject = null;

      self.selectedSubject = subject;
      self.showClasses = true;
    },
    saveEditClassroom() {
      var self = this;
      
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnElement("saveEditButton", 0.45, "material");

          self.formData.teacherId = self.teacherDropdown ? parseInt(self.teacherDropdown.value) : null;
          self.formData.courseId = self.subjectDropdown ? parseInt(self.subjectDropdown.value) : null;

          if (self.year) {
            self.formData.year = self.year.getFullYear();
          }

          var onSuccess = response => {
            if(self.formData.id) {
              self.classroomPopupActive = false;
            }
            else {
              self.formData.id = response.data;
              self.addUploaderClickEvents();
              self.loadStudentData(self.formData.id);
              self.getAssignedStudents(self.formData.id);
            }

            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Classroom Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.saveEditButton.$el);
          };

          self.$ajaxPost(self, "Company/AddEditCompany", self.formData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text:  self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    getIcon(id) {
      var self = this;
              
      if (self.math.includes(id))
        return mathsIcon;
      else if (self.mathLit.includes(id))
        return mathsliteracyIcon;
      else if (self.afrHuis.includes(id))
        return afrikaanshomeIcon;
      else if (self.afrEat.includes(id))
        return afrikaansfirstIcon;
      else if (self.engHome.includes(id))
        return englishhomeIcon;
      else if (self.engFal.includes(id))
        return englishfirstIcon;
      else if (self.lifeSkill.includes(id))
        return lifeskillsIcon;
      else if (self.lifeScience.includes(id))
        return lifesciencesIcon;
      else if (self.socScience.includes(id))
        return socialscienceIcon;
      else if (self.lifeOrient.includes(id))
        return lifeorientationIcon;
      else if (self.natSciTech.includes(id))
        return naturalscienceandtechnologyIcon;
      else if (self.geography.includes(id))
        return geographyIcon;
      else if (self.economics.includes(id))
        return economicsIcon;
      else if (self.accounting.includes(id))
        return accountingIcon;
      else if (self.tourism.includes(id))
        return tourismIcon;
      else if (self.natScience.includes(id))
        return naturalscienceIcon;
      else if (self.history.includes(id))
        return historyIcon;
      else if (self.egd.includes(id))
        return egdIcon;
      else if (self.tech.includes(id))
        return technologyIcon;
      else if (self.compAppTech.includes(id))
        return computerapptechnologyIcon;
      else if (self.it.includes(id))
        return itIcon;
      else if (self.elecTech.includes(id))
        return electricaltechnologyIcon;
      else if (self.mechTech.includes(id))
        return mechanicaltechnologyIcon;
      else if (self.civilTech.includes(id))
        return civiltechnologyIcon;
      else if (self.busStudy.includes(id))
        return businessstudiesIcon;
      else if (self.consStud.includes(id))
        return consumerstudiesIcon;
      else if (self.physScience.includes(id))
        return physicalscienceIcon;
      else if (self.chess.includes(id))
        return chessIcon;
      else if (self.arts.includes(id))
        return creativeartsIcon;
      else
        return defaultIcon;
    },
    cancelBulkAdd() {
      this.bulkCsvFileUrl = "";
      this.isBulkAddHidden = true;
      this.isLoading = false;
      this.canCancel = true;
      this.$vs.loading.close(this.$refs.bulkUpload.$el);
    },
    bulkStudentAdd() {
      this.isBulkAddHidden = false;
      this.scrollToFooter();
    },
    csvSuccessUpload(data) {
      this.isLoading = false;
      this.bulkCsvFileUrl = data[0].url;
    },
    confirmBulkStudentAdd() {
      var self = this;
      self.canCancel = false;
      self.showLoadingOnElement('confirmBulkButton', 0.35, 'material');

      var onSuccess = response => {
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: response.data,
          time: 7000,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.confirmBulkButton.$el);
        self.cancelBulkAdd();
        self.getAssignedStudents(self.formData.id);
      };
      
      self.$ajaxGet(self, "Company/BulkStudentAdd?fileUrl=" + self.bulkCsvFileUrl + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    loadStudentData(companyId) {
      const self = this;
      self.showLoadingOnElement("allStudentsTable", 1, "corners");

      var onSuccess = function (response) {
        self.students = [];

        if(self.criteria.unassignedPageNumber > 1)
          self.students[((self.criteria.unassignedPageNumber - 1) * self.unassignedPageSize) - 1] = {};

        self.students = self.students.concat(response.data.records);
          
        if (response.data.count > (self.criteria.unassignedPageNumber * self.unassignedPageSize))
            self.students[response.data.count - 1] = {};
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.allStudentsTable.$el);
      };

      self.$ajaxGet(self, "Company/ListUnassignedStudents?companyId="+ companyId +"&pageNumber=" + self.criteria.unassignedPageNumber + "&pageSize=" + self.criteria.unassignedPageSize + "&searchPhrase=" + self.criteria.unassignedSearchPhrase, onSuccess, onFinally);
    },
    getAssignedStudents(companyId) {
      const self = this;
      self.showLoadingOnElement("assignedStudentsTable", 1, "corners");

      var onSuccess = function (response) {
        self.assignedStudents = [];

        if (self.criteria.assignedPageNumber > 1)
          self.assignedStudents[((self.criteria.assignedPageNumber - 1) * self.assignedPageSize) - 1] = {};

        self.assignedStudents = self.assignedStudents.concat(response.data.records);

        if (response.data.count > (self.criteria.assignedPageNumber * self.assignedPageSize))
          self.assignedStudents[response.data.count - 1] = {};
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedStudentsTable.$el);
      };

      self.$ajaxGet(self, "Company/ListAssignedStudents?companyId=" + companyId + "&pageNumber=" + self.criteria.assignedPageNumber + "&pageSize=" + self.criteria.assignedPageSize + "&searchPhrase=" + self.criteria.assignedSearchPhrase, onSuccess, onFinally);
    },
    assignStudent(studentId) {
      
      var self = this;
      self.showLoadingOnElement("allStudentsTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: 'Student Assigned to Classroom',
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-user-check'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.allStudentsTable.$el);
        self.loadStudentData(self.formData.id);
        self.getAssignedStudents(self.formData.id);
      };

      self.$ajaxGet(self, "Company/AssignStudent?studentId=" + studentId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    unassignStudent(studentId) {
      var self = this;
      self.showLoadingOnElement("assignedStudentsTable", 1, "corners");
      
      var onSuccess = response => {
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: 'Student Unassigned from Classroom',
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-user-minus'
          
        });
      };
      
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.assignedStudentsTable.$el);
        self.loadStudentData(self.formData.id);
        self.getAssignedStudents(self.formData.id);
      };

      self.$ajaxGet(self, "Company/UnassignStudent?studentId=" + studentId + "&companyId=" + self.formData.id, onSuccess, onFinally);
    },
    selectElementContents(elId) {
      var el = document.getElementById(elId);
      var body = document.body, range, sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
        document.execCommand("copy");
        this.$vs.notify({
          color: "success",
          text: "Copied!",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-clipboard"
        });
      } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
        range.execCommand("Copy");
        this.$vs.notify({
          color: "success",
          text: "Copied!",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-clipboard"
        });
      }
      sel.removeAllRanges();
    },
    exportBulkToExcel() {
      var self = this;
      import('@/vendor/Export2Excel').then(excel => {
        const list = self.bulkAddResponse.studentsNotAdded;
        const data = self.formatJson(self.headerValBulk, list)
        excel.export_json_to_excel({
          header: self.headerTitleBulk,
          data,
          filename: `${self.bulkAddResponse.totalNotAdded}_students_not_added_for_classroom_${self.formData.companyName}`,
          autoWidth: false,
          bookType: "csv"
        })
      })
    },
    addUploaderClickEvents() {
      var self = this;

      self.$refs.bulkUpload.$el.addEventListener("click", function(){
        if(!self.isLoading) {
          self.isLoading = true;
          self.showLoadingOnElement("bulkUpload", 0.45, "material");
        }else{
          self.isLoading = false;
          self.$vs.loading.close(self.$refs.bulkUpload.$el);
        }
      });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    scrollToFooter() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -480,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("footerGlobal"),
        100,
        scrollOptions
      );
    },
    handleUnassignedStudentChangePage(pageNumber) {
      var self = this;

      if(pageNumber > 0) {
        self.criteria.unassignedPageNumber = pageNumber;
        self.criteria.showInactive = self.showInactive;

        self.loadStudentData(self.formData.id);
      }
    },
    handleUnassignedStudentsSearch(searchPhrase) {
      var self = this;

      if(searchPhrase.length >= 3){
        self.criteria.unassignedSearchPhrase = searchPhrase;

        self.loadStudentData(self.formData.id);
      }
      else if (searchPhrase == ""){
        self.criteria.unassignedSearchPhrase = searchPhrase;
        self.loadStudentData(self.formData.id);
      }
    },
    handleAssignedStudentChangePage(pageNumber) {
      var self = this;

      if (pageNumber > 0) {
        self.criteria.assignedPageNumber = pageNumber;
        self.criteria.showInactive = self.showInactive;

        self.getAssignedStudents(self.formData.id);
      }
    },
    handleAssignedStudentsSearch(searchPhrase) {
      var self = this;

      if(searchPhrase.length >= 3){
        self.criteria.assignedSearchPhrase = searchPhrase;

        self.getAssignedStudents(self.formData.id);
      }
      else if (searchPhrase == ""){
        self.criteria.assignedSearchPhrase = searchPhrase;
        self.getAssignedStudents(self.formData.id);
      }
    },
    getCurrentUserId() {
      var self = this;
	  
      var userIdFromLocalStorage = localStorage.getItem("Current_User_Id");

      if (userIdFromLocalStorage != undefined && userIdFromLocalStorage != null && userIdFromLocalStorage != "") {
        self.currentUserId = JSON.parse(userIdFromLocalStorage);
        return;
      }

      var onSuccess = response => {
        localStorage.setItem("Current_User_Id", response.data);
        self.currentUserId = JSON.parse(localStorage.getItem('Current_User_Id'));
      };
      self.$ajaxGet(self, "user/GetUserId", onSuccess);
    },
  },
  created() {
    if(!localStorage.getItem("userInfo")) {
      window.location.replace("/login");
    }
  },
  mounted() {
    var self = this;
    self.getSubjectsAndClassess();
    self.getTeachersDropdownData();
    self.getSubjectsDropdownData();
    self.getCurrentUserId();
  }
};
</script>

<style lang="scss">
  @import "../assets/main-digi.scss";

  #classroom-popup .vs-popup {
    background: rgb(65, 71, 94) !important;
    color: rgb(202, 202, 202) !important;
    >.vs-popup--header {
      background: rgb(38, 45, 74) !important;

      > div > h3 {
        color: rgb(255, 255, 255) !important;
      }
    }

    .vs-popup--content {
      height: inherit !important;
    }
  }

  #bulkNotAddedPopup div.vs-popup {
    width: 1000px;
  }

  div#bulkNotAddedPopup.vs-component.con-vs-popup.vs-popup-primary {
    div.vs-popup {
      header.vs-popup--header {
        i.vs-icon.notranslate.icon-scale.vs-popup--close.vs-popup--close--icon.material-icons.null {
          background: rgb(253, 0, 0) !important;
          color: rgb(255, 255, 255);
        }
      }
    }
  }

  #teacher-dropdown-container {
    .v-select.disabled .dropdown-toggle, .v-select.disabled .dropdown-toggle .clear, .v-select.disabled .dropdown-toggle input, .v-select.disabled .open-indicator, .v-select.disabled .selected-tag .close {
      cursor: not-allowed;
      background-color: #525252 !important;
    }
  }

  .vs-progress--background {
    text-align: left !important;
  }

  .theme-dark .vs-popup--close--icon {
    color: white !important;
  }






  //prototype
  .listing--item {
    cursor: pointer;
    box-shadow: 3px 3px 6px 3px rgba(0, 0, 0, 0.2) !important;
    transition: transform .15s ease-in, box-shadow .2s ease-in;

    &:hover {
      transform: scale(1.035);
      box-shadow: 0px 5px 6px 3px rgba(0, 0, 0, 0.3) !important;
    }
  }
</style>
